<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Helpers
	import { real_id } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Radio } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device;

	const deviceID = real_id(device.id);
	const component = `light:${device.channel}`;
	const settings = devices_settings.getByRealId(device.id);

	const modes = ['0-10v', '1-10v']; //didn't implement translations because maybe not needed

	let selected = settings[component]?.op_mode;
	let loading = false;

	const sentRequests = async () => {
		if (loading || selected === settings[component]?.op_mode) return;
		loading = true;
		const res: SettingRequest = await gen2Request(device, 'light.SetConfig', {
			id: device.channel,
			config: { op_mode: selected },
		});
		if (res.isok) {
			settings[component].op_mode = selected;
			devices_settings.update_devices_settings(deviceID, settings);
		} else {
			selected = settings[component]?.op_mode;
		}
		onSettingsResponse(res, device);
		loading = false;
	};
	const changeMode = async (mode) => {
		if (loading) return;
		selected = mode;
	};
</script>

{#each modes as mode, i}
	<Radio
		size="m"
		class="mb-s"
		bind:selected={modes[selected]}
		value={mode}
		on:click={() => changeMode(i)}
		id="radio-1jzjgk9"
	>
		{mode}
	</Radio>
{/each}

<Button size="m" width="full" {loading} on:click={sentRequests}>{$format('button_save')}</Button>
